import * as React from "react";
import { IconButton, styled } from "@mui/material";
import { useState } from "react";
import EditIcon from "@mui/icons-material/Edit";

//region [[ Styles ]]

const TableRow = styled("div")({
  display: "flex",
  flexFlow: "row",
  alignItems: "center",
  position: "relative",
});

const TableCell = styled("div")({
  padding: "15px",
  display: "flex",
  flexFlow: "row",
  alignItems: "center",
  justifyContent: "center",
  borderRadius: "15px",
  margin: "3px",
  backgroundColor: "aliceblue",
  width: "calc(100% / 9)",
  overflow: "hidden",
  fontSize: "10px",
});

export const TitleCell = styled(TableCell)({
  backgroundColor: "#efefef",
});

//endregion [[ Styles ]]

//region [[ Props ]]

export interface PatientTableRowProps {
  index: number;
  key: string;
  item: Record<string, any>;
  matches: [];
  onEditItem: (item, index) => void;
}

//endregion [[ Props ]]

//region [[ Functions ]]
const highlight = (value, indices = [], i = 1) => {
  const pair = indices[indices.length - i];
  return !pair ? (
    value
  ) : (
    <>
      {highlight(value.substring(0, pair[0]), indices, i + 1)}
      <mark>{value.substring(pair[0], pair[1] + 1)}</mark>
      {value.substring(pair[1] + 1)}
    </>
  );
};

const entryAsString = (entry, match) => {
  if (typeof entry === "string") {
    if (match) {
      return highlight(entry, match?.indices);
    }
    return entry;
  }
  return JSON.stringify(entry, null, 2) || "";
};
//endregion [[ Functions ]]

export const PatientTableRow = React.memo(
  ({ index, key, item, matches, ...props }: PatientTableRowProps) => {
    const [showEditButton, setShowEditButton] = useState(false);

    return (
      <TableRow
        key={index}
        onMouseEnter={() => setShowEditButton(true)}
        onMouseLeave={() => setShowEditButton(false)}
      >
        {showEditButton && (
          <IconButton onClick={() => props.onEditItem(item, index)}>
            <EditIcon />
          </IconButton>
        )}
        <TitleCell>{item?.["index"] || index}</TitleCell>
        {Object.entries(item || {}).map(([key, entry], entryId) => {
          const match = matches.find(
            (m: PatientTableRowProps) => m.key === key,
          );
          if (key === "index") return null;
          return (
            <TableCell key={`${index}_${entryId}`}>
              {entryAsString(entry, match)}
            </TableCell>
          );
        })}
      </TableRow>
    );
  },
);
